module.exports = __webpack_public_path__ + "img/barva-zakladni_08_temne-modra.de9c6aba.png";